import './Footer.css'

export default function Footer() {
  return (
    <footer id="footer">
    <p className="copyRight">&copy; Pets &amp; Me</p>
</footer>
  );
}